/**
 * Copyright (c) 2024-2026 Creative Agentics Limited. All rights reserved.
 * Proprietary and confidential. Unauthorised use, reproduction or distribution
 * of this software, in whole or in part, is strictly prohibited.
 * See LICENSE.txt for full terms.
 */

// THE FIRM'S NAMED OFFICERS (v1_835, policy questionnaire sections 10 and 11).
// Signing writes compliance_config.policyOfficers: the policy approver (section
// 10) and the named MLRO, deputy and override approver (section 11). Display and
// record only: the sign off dialog shows the policy approver, and the decision
// record stores the policy approver beside the officer who recorded the
// decision, and the override approver when the decision departs from the AI's.
// Nothing here decides who may approve or what blocks approval. Pure.

const clean = (v) => String(v == null ? '' : v).replace(/\s+/g, ' ').trim().slice(0, 200);

export function policyOfficersOf(src) {
  const p = (src && src.policyOfficers && typeof src.policyOfficers === 'object') ? src.policyOfficers : (src && typeof src === 'object' && !('policyOfficers' in src) && ('approver' in src || 'overrideApprover' in src) ? src : {});
  return { approver: clean(p.approver), mlro: clean(p.mlro), deputy: clean(p.deputy), overrideApprover: clean(p.overrideApprover) };
}

export const NOT_NAMED = 'not named in the firm\'s policy';
export const policyApproverLine = (po) => `Policy approver: ${policyOfficersOf(po).approver || NOT_NAMED}`;

// What the decision record stores (aiAgreement from the record itself).
export function decisionOfficers(po, aiAgreement) {
  const o = policyOfficersOf(po);
  return { policyApprover: o.approver || null, ...(aiAgreement === 'overridden' ? { overrideApprover: o.overrideApprover || null } : {}) };
}
